<div class="">
    <mat-dialog-content class="account-box" style="overflow: hidden; scroll-behavior: unset;">
        <div class="text-center ">
            <img class="rank-img" src="assets/img/rank-icon-green.svg" alt="">
        </div>

        <div class="accont-created text-center mt-3 mb-2" style="margin-bottom:14px;">
            <h4 style="font-weight: 600; font-size: 20px; color: #1E2A36;" *ngIf='data?.message'>Your rank might be between<br><span><strong>{{ data?.message }}.</strong></span></h4>
            <!-- <h4 style="font-weight: 600; font-size: 20px; color: #1E2A36;" *ngIf='!data?.message'><span><strong>You are Not Qualified</strong></span></h4> -->
        </div>

        <div class="account-confirm-links text-center mt-2" style="margin-bottom:24px;">
            <a class="" (click)="closeDialog()">
                <!-- Personlize content in 4 quick steps  -->
                Close
            </a>
        </div>
        </mat-dialog-content>
    </div> 